<template>
    <div class="quick-view-swiper">
        <Swiper  v-bind="swiperOptions">
            <SwiperSlide v-if="images && images?.front">
                <div class="d-flex justify-content-center align-items-center">
                    <img width="250" height="250"  :src="images.front" alt="front">
                </div>
            </SwiperSlide>

            <template v-for="(image, key) in images" :key="key">
                <SwiperSlide v-if="image && key !=='front'">
                     <div class="d-flex justify-content-center align-items-center">
                         <video v-if="image?.includes('.mp4')" @contextmenu.prevent="" controlsList="nodownload" ref="video" controls width="250" height="250" autoplay loop muted playsinline>
                             <source :src="image" type="video/mp4" />
                             Your browser does not support the video tag.
                         </video>
     
                         <iframe v-else-if="image?.includes('.html') || image?.includes('loupe360.com')" :src="image" style="width: 100%; height:300px;" class="grid-iframe "></iframe>
     
                         <img width="250" height="250"  v-else :src="image" :alt="key">
                     </div>
                </SwiperSlide>
            </template>
            <div class="quick-view-pg swiper-pagination"></div>
        </Swiper>
    </div>
</template>
<script setup>
import { Pagination } from 'swiper/modules';

const { images } = defineProps(['images'])

const swiperOptions = {
      spaceBetween: 20,
      modules: [Pagination],
      pagination: {
        clickable: true,
        disableOnInteraction: false,
        el:'.quick-view-pg'
    },
  };

</script>

<style scoped>



img,
video,
iframe {
    border-radius: 8px;
}

video,img {
    max-width: 100%;
    height: auto;
}

.quick-view-swiper {
    width: 100%;
}


:global(.quick-view-swiper .swiper-slide) {
    height: auto !important;
}

/* swiper pagination: mobile */
:global(.quick-view-swiper .swiper-pagination) {
    position: relative;
    margin-top: 1rem;
}

:global(.quick-view-swiper .swiper-pagination-bullet) {
    background: transparent !important;
    opacity: 1 !important;
    margin: 0 5px !important;
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 0 !important;
}

:global(.quick-view-swiper .swiper-pagination-bullet::before) {
    content: '';
    position: absolute;
    top: 50%;   
    left: 50%;
    transform: translate(-50%, -50%);
    z-index:   -1;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: #c4c4c4 !important;
    opacity: 1 !important;
}

:global(.quick-view-swiper .swiper-pagination-bullet-active::before) {
    background: #606060 !important;
}
</style>